import { render, staticRenderFns } from "./MenuSettingsFrame.vue?vue&type=template&id=4d72abef&scoped=true&"
import script from "./MenuSettingsFrame.vue?vue&type=script&lang=js&"
export * from "./MenuSettingsFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72abef",
  null
  
)

export default component.exports